import React from 'react'
import Reflux from 'reflux-react-16'

import _ from 'lodash'
import moment from 'moment'

import OrderStore from '../stores/OrderStore.js'
import OrderActions from '../actions/OrderActions.js'
import AddressStore from '../../src/stores/AddressStore.js'

import {RouteMap, SelectRoutePopup} from '../components/index.js'
import {Button, IconButton, Popup, Panel, ListItem, Popover, Colors} from '../../src/components/UI/index.js'

import geolocation from '../utils/geolocation.js'
import utils from '../utils/utils.js'
import questionOptions from '../utils/questionOptions.js'
import stopBundles from '../../utils/stopBundles.js'
import ColliNotReadyPopup from '../components/UI/ColliNotReadyPopup.js'
import {emit} from 'messenger/socketio/socketEmit.js'
import t from 'src/helpers/Languages.js'

export default class Map extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            orderId: this.props.location?.state?.orderId,
            addressIndex: this.props.location?.state?.addressIndex,
            focusEndPoint: this.props.location?.state?.focusEndPoint
        }

        this.stores = [OrderStore, AddressStore]
    }

    componentDidMount() {
        localStorage.lastView = '/koerier/kaart'
    }

    async onClickStart() {
        try {
            let {route, shift, location} = this.state
            const {reseller, branding} = this.props

            const gpsRequired = _.some(route.orders, (order) => {
                return _.some(order.addresses, (address) => address.gpsRequired)
            })

            if (gpsRequired) {
                await geolocation.checkPermissions()
            }

            const orderColli = {}
            const colliNotReady = []

            route.colli.map((collo) => {
                if (!collo.started && collo.ready) {
                    orderColli[collo.orderId] = orderColli[collo.orderId] || []
                    orderColli[collo.orderId].push(collo)
                }

                if (!collo.ready) {
                    colliNotReady.push(collo)
                }
            })

            const startUnloadedColli = !route?.loadingRequiredBeforeStart && (!route.loaded || Object.keys(orderColli).length === 0)

            const startRoute = async (noPopup = false) => {
                const startRouteAction = () => {
                    OrderActions.startRoute(route._id, startUnloadedColli, async (err, errors) => {
                        if (err) {
                            this.popup.setError(err)
                        } else if (errors.length) {
                            this.popup.setErrors(errors)
                        } else {
                            this.popup.close()

                            const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'route')?.id

                            if (shift && activityId) {
                                if (!location?.lat) {
                                    location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                }

                                try {
                                    await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                } catch (error) {
                                    console.error(error)
                                }
                            }
                        }
                    })
                }

                const routeNotOptimized = route.addresses.some((address) => typeof address.priority !== 'number')

                if (reseller.settings.routeNotOptimizedWarning === 'notallowed' && routeNotOptimized) {
                    this.popup.setActionButtons([{
                        variant: 'solid',
                        color: branding?.color || Colors.brandColor,
                        label: t('optimizeAndStart'),
                        onClick: async () => {
                            try {
                                await emit('orders.planRoute', {routeId: route._id, optimize: true})
                                this.popup.close()
                                startRouteAction()
                            } catch (err) {
                                this.popup.setError(err.message || err.toString())
                            }
                        }
                    }])
                    if (!await this.popup.open('Route starten', 'Route is niet geoptimaliseerd. Optimaliseer de route voordat je deze start.')) return
                    return
                } else if (reseller.settings.routeNotOptimizedWarning === 'warning' && routeNotOptimized) {
                    this.popup.setWarning('Route is niet geoptimaliseerd. Wil je de route toch starten?')
                    if (!await this.popup.open('Route starten')) return
                    startRouteAction()
                } else {
                    if (noPopup) {
                        startRouteAction()
                    } else {
                        if (!await this.popup.open('Route starten', 'Weet je zeker dat je deze route wilt starten?')) return
                        startRouteAction()
                    }
                }
            }

            if (!startUnloadedColli && colliNotReady.length > 0) {
                this.colliNotReadyPopup.open(colliNotReady, startRoute, () => {
                    this.setState({loading: false})
                })
            } else {
                startRoute()
            }
        } catch (err) {
            await this.popup.setError(err.message || err?.toString())
        }
    }

    async onClickPickupDeliver(address, barcode) {
        const {history, reseller} = this.props

        const deviation = utils.nextStopDeviation(reseller, address)

        if (deviation === 'notallowed') {
            await this.popup.openAlert('Let op!', 'Dit adres is niet de volgende stop van de route.')
        } else if (deviation === 'warning') {
            if (await this.popup.openBoolean('Let op!', `Dit adres is niet de volgende stop van de route. Wil je deze toch nu ${address.type === 'pickup' ? 'ophalen' : 'bezorgen'}?`, questionOptions())) {
                history.push(stopBundles.stopPath(address), {barcode})
            }
        } else {
            history.push(stopBundles.stopPath(address), {barcode})
        }
    }

    async onClickSelectRoute() {
        const {date, routes, selectedRoute} = this.state
        const {history} = this.props

        const {newDate, newSelectedRoute} = await this.selectRoutePopup.open(date, routes, selectedRoute)

        if (newDate !== date) {
            OrderActions.setDate(newDate)
        } else if (newSelectedRoute !== selectedRoute) {
            OrderActions.selectRoute(newSelectedRoute)
            history.push('/koerier/route')
        }
    }

    render() {
        const {date, shift, routes, route, isScanning, orderId, addressIndex, focusEndPoint} = this.state
        const {reseller, user, branding, onClickNavigation} = this.props

        const currentActivity = shift && reseller.settings.shifts?.activities?.find((activity) => activity.id === shift.activityId)
        const shiftStartRequired = (reseller.settings.shifts?.shiftRequired && (!shift || !shift?.started || shift?.paused || shift?.completed)) || currentActivity?.lockAppActivity

        return (
            <>
                {!isScanning &&
                    <Panel style={{display: 'flex', gap: 6, width: '100%', padding: '12px 6px 12px 6px', borderTop: 'none', borderRight: 'none', borderLeft: 'none'}}>
                        <div style={{width: 36}}>
                            <IconButton
                                onClick={this.onClickSelectRoute.bind(this)}
                                badge={Object.values(routes).filter((r) => !r.completed && r._id !== route._id).length}
                            >
                                <i className='mdi mdi-map-marker-path' />
                            </IconButton>
                        </div>

                        <div style={{flex: 1}}>
                            {route?.loadingRequiredBeforeStart && !route.loaded && !route.started &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-barcode-scan'
                                    label='Route inladen'
                                    disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || shiftStartRequired}
                                    onClick={async () => {
                                        let {location} = this.state

                                        OrderActions.startScanning()
                                        history.push('/koerier/adressen')

                                        const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                        if (shift && activityId) {
                                            if (!location?.lat) {
                                                location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                            }

                                            try {
                                                await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                            } catch (error) {
                                                console.error(error)
                                            }
                                        }
                                    }}
                                />
                            }

                            {(route?.loadingRequiredBeforeStart ? route.loaded : route.loaded ? !route.started : (route.hasReadyToStartColli || (route.hasUnstartedColli && !route.hasStartedColli))) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-arrow-right-bold-circle'
                                    label='Route starten'
                                    disabled={date !== moment().format('YYYY-MM-DD') || !route.hasReadyToStartColli || shiftStartRequired}
                                    onClick={this.onClickStart.bind(this, route.ids)}
                                />
                            }

                            {!route.completed && (route.loaded ? route.started : (!route.hasReadyToStartColli && route.hasStartedColli)) &&
                                <Button
                                    variant='solid'
                                    color={branding?.color || Colors.brandColor}
                                    style={{flex: 1}}
                                    icon='mdi mdi-flag-checkered'
                                    label='Route afronden'
                                    disabled={route.hasUnCompletedColli || shiftStartRequired}
                                    onClick={() => {
                                        this.popup.open('Route afronden', 'Weet je zeker dat je deze route wilt afronden?', () => {
                                            let {location} = this.state

                                            OrderActions.stopRoute(route._id, async (err, errors) => {
                                                if (err) {
                                                    this.popup.setError(err)
                                                } else if (errors.length) {
                                                    this.popup.setErrors(errors)
                                                } else {
                                                    this.popup.close()
                                                    history.push('/koerier/route')

                                                    const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'other')?.id

                                                    if (shift && activityId) {
                                                        if (!location?.lat) {
                                                            location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                        }

                                                        try {
                                                            await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                        } catch (error) {
                                                            console.error(error)
                                                        }
                                                    }
                                                }
                                            })
                                        })
                                    }}
                                />
                            }
                        </div>

                        <div style={{width: 36}}>
                            <Popover
                                placement='left'
                                popoverStyle={{width: 200}}
                                content={
                                    <>
                                        <ListItem
                                            icon='mdi mdi-barcode-scan'
                                            disabled={date !== moment().format('YYYY-MM-DD') || _.keys(routes).length === 0 || !route.hasUnstartedColli || shiftStartRequired}
                                            onClick={async () => {
                                                let {location} = this.state

                                                OrderActions.startScanning()
                                                history.push('/koerier/adressen')

                                                const activityId = reseller.settings.shifts?.activities?.find((activity) => activity.trigger === 'loading')?.id

                                                if (shift && activityId) {
                                                    if (!location?.lat) {
                                                        location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                                                    }

                                                    try {
                                                        await emit('shifts.startActivity', {id: shift._id, activityId, location})
                                                    } catch (error) {
                                                        console.error(error)
                                                    }
                                                }
                                            }}
                                        >
                                            Route inladen
                                        </ListItem>
                                    </>
                                }
                            >
                                <IconButton>
                                    <i className='mdi mdi-dots-vertical' />
                                </IconButton>
                            </Popover>
                        </div>
                    </Panel>
                }

                <RouteMap
                    reseller={reseller}
                    user={user}
                    loading={this.state.loading}
                    history={history}
                    route={route}
                    orderId={orderId}
                    addressIndex={addressIndex}
                    focusEndPoint={focusEndPoint}
                    onClickPickupDeliver={this.onClickPickupDeliver.bind(this)}
                    onClickNavigation={onClickNavigation}
                    disabled={shiftStartRequired}
                />

                <Popup ref={(ref) => this.popup = ref} />
                <SelectRoutePopup ref={(ref) => this.selectRoutePopup = ref} reseller={reseller} />
                <ColliNotReadyPopup ref={(ref) => this.colliNotReadyPopup = ref} />
            </>
        )
    }
}
